module.exports = __webpack_public_path__ + "img/icon 1@3x.6c14fa8e.png";